/* eslint-disable @typescript-eslint/no-var-requires */
/**
 * Fitxer: AppState
 * Autor: Jordi Riu Amblàs
 * Data: 18/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 */
import { AjtAppState } from 'ajt-app';
 
const pjson = require('../../package.json');
 
const _entorn = (window.location.href.toLowerCase().lastIndexOf('manresa.cat') < 0 
                    ? (window.location.href.toLowerCase().lastIndexOf('localhost') < 0 
                        ? 'intranet' 
                        : 'local')
                    : 'internet');
 
                    export default class AppState extends AjtAppState {
    constructor() {
        super({
            titol: 'Mapes de l\'Ajuntament de Manresa',
            subtitol: 'versió ' + pjson.version,
            showVersions: true,
            urlBase: '/sigmap',
            urlBaseSessApi: (_entorn === 'internet' ? 'https://manresa.cat/webapi/Public/Menus/1.0' : 'http://intranetserver/intranet/public/Menus/1.0/api')
            // urlBaseSessApi: 'https://manresa.cat/webapi/Public/Menus/1.0'
            /*,
            recCod: '[recurs de l\'aplicació]'*/
        });
    }

    public entorn: string = _entorn;
 
}